<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="23"
       viewBox="0 0 26 23">
    <defs>
      <linearGradient id="1z039lh9xa" x1="50%" x2="50%" y1="1.3%" y2="101.3%">
        <stop offset="0%" stop-color="#DE04C5"/>
        <stop offset="100%" stop-color="#D8006C"/>
      </linearGradient>
      <linearGradient id="26zgvkiyub" x1="50%" x2="50%" y1="1.3%" y2="101.3%">
        <stop offset="0%" stop-color="#F700DB"/>
        <stop offset="100%" stop-color="#FF0080"/>
      </linearGradient>
      <linearGradient id="p137stw3wd" x1="50%" x2="50%" y1="1.3%" y2="101.3%">
        <stop offset="0%" stop-color="#F700DB"/>
        <stop offset="100%" stop-color="#FF0080"/>
      </linearGradient>
      <linearGradient id="q9smad8oqe" x1="50%" x2="50%" y1="1.3%" y2="101.3%">
        <stop offset="0%" stop-color="#F700DB"/>
        <stop offset="100%" stop-color="#FF0080"/>
      </linearGradient>
      <linearGradient id="jtigo1x7uf" x1="50%" x2="50%" y1="1.3%" y2="101.3%">
        <stop offset="0%" stop-color="#E60073"/>
        <stop offset="100%" stop-color="#D200BA"/>
      </linearGradient>
      <path id="zo0p31nvhc"
            d="M18.54 15.292c-.172 1.333-.66 2.475-1.463 3.428l-6.134 3.694c.909-.825 1.435-2.086 1.579-3.784l.006.006z"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <path fill="url(#1z039lh9xa)"
                  d="M0 12.672l13.053 5.62.099.95c-.206.817-.555 1.555-1.05 2.166-2.172 2.673-6.356 1.9-9.347-1.724C1.028 17.589.076 15 0 12.672z"
                  transform="translate(-175 -736) translate(62 736) translate(113)"/>
            <g transform="translate(-175 -736) translate(62 736) translate(113)">
              <use fill="url(#26zgvkiyub)" xlink:href="#zo0p31nvhc"/>
              <use fill="#000" fill-opacity=".115" xlink:href="#zo0p31nvhc"/>
            </g>
            <path fill="url(#p137stw3wd)" d="M0 12.67L5.478 9.726 18.537 15.314 12.528 18.636z"
                  transform="translate(-175 -736) translate(62 736) translate(113)"/>
            <g>
              <g>
                <path fill="url(#q9smad8oqe)"
                      d="M1.29 4.32c2.195-2.646 6.425-1.881 9.447 1.707 1.968 2.336 2.94 5.293 2.772 7.803l-.497.35L.003 8.613C-.042 6.949.375 5.425 1.291 4.32z"
                      transform="translate(-175 -736) translate(62 736) translate(113) translate(7.507)"/>
                <path fill="url(#jtigo1x7uf)"
                      d="M13.37.952c1.247.686 2.485 1.93 3.715 3.73.935 1.758 1.403 3.508 1.403 5.25 0 .298-.014.59-.041.874l-5.396 3.375c.023-.3.035-.615.035-.945 0-2.11-.533-3.971-1.599-5.58C10.33 5.986 8.854 4.78 7.06 4.035c-1.683-.699-3.125-.955-4.327-.77l-.237.043L8.71.16c.959-.307 2.792-.238 4.66.792z"
                      transform="translate(-175 -736) translate(62 736) translate(113) translate(7.507)"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: 'FooterLogoSvg'
}
</script>
